export default __webpack_public_path__ + "static/media/symphony-innovate-logo.1d504464.svg";